import { useMemo } from "react";
import { Property as V3Property } from "../../../rest/responses/Property";
import EpcRatingTile from "../EpcRatingTile/EpcRatingTile";
import Uprn from "../Uprn/Uprn";

import "./MiniTable.scss";

function formatAddress(property: V3Property): string {
	const addrNo = property["location.addr_no"];
	const addrStreet = property["location.addr_street"];
	const addrCity = property["location.addr_city"];
	const postcode = property["location.postcode"];

	if (!addrNo && !addrStreet && !addrCity && !postcode) return "Not available";

	return `${addrNo} ${addrStreet}, ${addrCity}, ${postcode}`;
}

interface MiniTableProps {
	properties: V3Property[];
}

export default function MiniTable({ properties }: MiniTableProps) {
	// NB: Memoized so it doesn't re-render when you're doing things like typing into the group modal form
	return useMemo(() => {
		return (
			<table className="mini-table">
				<thead>
					<tr>
						<th>UPRN</th>
						<th>Address</th>
						<th>EPC</th>
					</tr>
				</thead>
				<tbody>
					{properties?.map((property) => {
						// NB: Hack to fix address not showing here.
						return (
							<tr key={property.id}>
								<td>
									<Uprn propertyId={property.id}>{property.uprn}</Uprn>
								</td>
								<td>{formatAddress(property)}</td>
								{property["metrics.epc_rating_grade"] && (
									<td className="epc-rating-container">
										<EpcRatingTile grade={String(property["metrics.epc_rating_grade"])} />
									</td>
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	}, [properties]);
}
